goog.provide("shadow.js.shim.module$bignumber");
goog.provide("module$shadow_js_shim_module$bignumber");
shadow.js.shim.module$bignumber = shadow.js.nativeProvides["bignumber.js"] = shadow$bridge("bignumber.js");
module$shadow_js_shim_module$bignumber.default = shadow.js.shim.module$bignumber;
